module.exports = __webpack_public_path__ + "static/media/love.dcf9cd99.png";